import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {TextCharLimit, Stack, Box, Typography, Button, Paper, Divider} from 'views/components';

import {translate, Translate, MarkdownEditor} from 'views/module';
import {useNavigate} from 'views/module';

import backend from 'utils/backend';

const DEFAULT_CLIENT_DATA = {
  clientName: '',
  description: {
    blob: '',
    editorType: 'MARKDOWN',
  },
};

const NewClient = (props) => {
  const [newClientData, setNewClientData] = React.useState(DEFAULT_CLIENT_DATA);
  const [newClientDataValid, setNewClientDataValid] = React.useState(false);

  const navigate = useNavigate();

  const progressWrap = props.statusProgressWrap;

  const clientName = newClientData.clientName || '';
  const description = newClientData?.description?.blob || '';

  const setclientName = (newValue) => {
    setNewClientData((e) => {
      return {
        ...e,
        clientName: newValue,
      };
    });
  };
  const setDescription = (newValue) => {
    setNewClientData((e) => {
      return {
        ...e,
        description: {
          blob: newValue,
          editorType: 'MARKDOWN',
        },
      };
    });
  };

  React.useEffect(() => {
    setNewClientDataValid(Boolean(clientName));
  }, [clientName]);

  const isSubmitDisabled = () => {
    return !newClientDataValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    progressWrap(async () => {
      const result = await backend.client.createClient(newClientData);

      navigate(`/client/${result.clientRn}`);
    });
  };

  return (
    <Paper sx={{p: {xs: 1, md: 2}}}>
      <Stack direction='column' spacing={2} wrap='nowrap'>
        <Box>
          <Typography variant='h4' sx={{fontWeight: 500}}>
            <Translate expression='client.ClientNew.Title' />
          </Typography>
        </Box>
        <Divider variant={'middle'}/>
        <Box>
          <TextCharLimit
            label={translate('client.ClientNew.ClientName')}
            value={clientName}
            onChange={setclientName}
            charLimit={180}
          />
        </Box>
        <Stack spacing={1}>
          <Box sx={{display: 'flex', alignContent: 'left'}}>
            <Typography variant='description1' sx={{fontWeight: 500}}>
              <Translate expression='client.ClientNew.ClientDescription' />
            </Typography>
          </Box>
          <Box xs={12}>
            <MarkdownEditor
              value={description}
              onChange={setDescription}
            />
          </Box>
        </Stack>
        <Box>
          <Stack>
            <Button
              color={'primary'}
              disabled={isSubmitDisabled()}
              onClick={handleSubmit}
              label={translate('client.ClientNew.CreateNewClient')}
              sx={{
                p: '8px 22px 8px 22px',
              }}
            />
            <Button
              variant='text'
              href='/client'
              label={translate('generic.Cancel')}
              sx={{
                'textTransform': 'none',
                'textDecoration': 'underline',
                'fontSize': '12px',
                'fontWeight': 'bold',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}/>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

NewClient.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NewClient));
